import Swiper from 'swiper/js/swiper';

jQuery(function() {

  if ($('.partner-slider-container').length > 0) {
    let spaceBetween = 20,
      slidesOffsetAfter = 20;
    if (window.innerWidth > 576) { //$screen-sm-min
      spaceBetween = 50;
      slidesOffsetAfter = 50;
    }
    new Swiper('.partner-slider-container', {
      slidesPerView: 'auto',
      loop: true,
      spaceBetween: spaceBetween,
      effect: 'slide',
      slidesOffsetAfter: slidesOffsetAfter,
      freeMode: true,
      freeModeSticky: true,
      navigation: {
        nextEl: '.partner-slider-button-next',
        prevEl: '.partner-slider-button-prev',
      },
    });
  }

});
